import type { TileColor } from '../../TileColor';
import { generateId } from '../../../../utils/generateId';

export class TileModel {
  public id = generateId('t');

  constructor(public readonly color: TileColor) {}
}
